export default class ViewTextAreaVO
{

	// ----------------------------------
	//	Properties
	// ----------------------------------

	customObjectsTemplate = "{ field: 'Name'}"; // Default value
	fieldType = 'customObjects';
	uiComponent = 'view-custom-objects-field';
	description = 'Add custom objects to a predefined structure.';

	constructor()
	{
		
	}
}